import { render } from "./FormTags.vue?vue&type=template&id=93ceb732"
import script from "./FormTags.vue?vue&type=script&lang=js"
export * from "./FormTags.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__